import type { FC, ReactNode } from 'react';

import { S } from '../styles';
import { useTileRenderLowestPrice } from '~/components/shared/recommendations/tile/hooks/useTileRenderLowestPrice';
import { ProductDataInfo } from '~/components/shared/recommendations/tile/productData/ProductDataInfo';
import { TilePriceLowest30Days } from '~/components/shared/recommendations/tile/TilePriceLowest30Days';

type ProductDataProps = {
  availableColors?: ReactNode;
  productInfo?: ReactNode;
};

export const ProductData: FC<ProductDataProps> = ({ availableColors, productInfo }) => {
  const renderLowestPrice = useTileRenderLowestPrice();

  return (
    <S.ProductData>
      <S.RelativeElement>
        <S.InformationArea>
          <ProductDataInfo renderLowestPrice={renderLowestPrice}>{productInfo}</ProductDataInfo>
          {renderLowestPrice ? (
            // readonly: the hovered variant's lowest price is shown by ProductDataHoverCard
            <TilePriceLowest30Days readonly>{availableColors}</TilePriceLowest30Days>
          ) : (
            availableColors
          )}
        </S.InformationArea>
      </S.RelativeElement>
    </S.ProductData>
  );
};
